module.exports = __webpack_public_path__ + "img/mouth_female_average.e285658c.png";